
import CSearchList from '@/components/c-search-list'
import CTable from '@/components/c-table'
import { getIndexConfig, getTableConfig, inputList } from './config'
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import { dropdownOfEnterprise, getList, resetTodo, deleteTodo } from './api'
import { toResult } from '@/utils/toResult'
import { usePagination } from '@/hooks/usePagination'
import { ElMessage, ElMessageBox } from 'element-plus'

export default defineComponent({
  name: 'record-contract-todo', // 备案合同待办
  components: {
    CSearchList,
    CTable
  },
  setup() {
    // 企业名称远程搜索
    const remoteData1 = reactive({
      options: [] as any[],
      isLoading: false,
      remoteMethod: (val: string) => {
        dropdownOfEnterprise({ value: val }).then((res: any) => {
          remoteData1.options = (res.data || []).map((item: any) => {
            return {
              label: item.value,
              value: item.key
            }
          })
        })
      }
    })

    const data = reactive({
      inputList: inputList({ ...toRefs(remoteData1) }),
      ...getIndexConfig()
    })

    const tableConfig = reactive({
      ...getTableConfig()
    })

    const getListFn = async () => {
      const p = {
        ...data.queryForm,
        currPage: tableConfig.pagination.currentPage,
        pageSize: tableConfig.pagination.pageSize
      }

      tableConfig.loading = true
      const [err, res] = await toResult(getList(p))
      tableConfig.loading = false
      if (err) return
      tableConfig.data = res.list || []
      tableConfig.pagination.total = res.total
    }

    // 查询
    const handleSearch = (params: object) => {
      tableConfig.pagination.currentPage = 1
      params && (data.queryForm = { ...params })
      getListFn()
    }

    // 重置
    const handleReset = (val: object) => {
      data.queryForm = val
    }

    // 重置待办
    const handleResetTodo = (row: any) => {
      ElMessageBox.confirm('确定重置该待办吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          // toResult 返回 [err, data.data, data.msg]，重置接口无业务数据，取 msg
          const [err, , msg] = await toResult(resetTodo({ id: row.id }))
          if (err) return
          ElMessage.success(msg || '重置成功')
          getListFn()
        })
        .catch(() => {})
    }

    // 删除待办
    const handleDeleteTodo = (row: any) => {
      ElMessageBox.confirm('确定删除该待办吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          // toResult 返回 [err, data.data, data.msg]，删除接口无业务数据，取 msg
          const [err, , msg] = await toResult(deleteTodo({ id: row.id }))
          if (err) return
          ElMessage.success(msg || '删除成功')
          getListFn()
        })
        .catch(() => {})
    }

    const { pageCurrentChange, pageSizeChange } = usePagination(
      tableConfig.pagination,
      () => {
        getListFn()
      }
    )

    onMounted(() => {
      handleSearch({})
    })

    return {
      ...toRefs(data),
      handleSearch,
      handleReset,
      handleResetTodo,
      handleDeleteTodo,
      tableConfig,
      pageCurrentChange,
      pageSizeChange,
      getListFn
    }
  }
})
